<template>
  <v-card id="dish-list">
    <v-card-text class="d-flex align-center flex-wrap pb-0">
      <div class="me-4 pb-4">
        <div class="text-h6">
          {{ categoryName || 'Блюда' }}
        </div>
        <div class="text-caption text--secondary">
          {{ toDishCount(totalCount) }}
        </div>
      </div>

      <v-spacer></v-spacer>

      <div class="dish-list__tools d-flex align-center flex-wrap pb-4">
        <v-text-field
          v-model="filters.searchQuery"
          single-line
          dense
          outlined
          hide-details
          clearable
          placeholder="Поиск по блюдам..."
          class="dish-list__search"
          :prepend-inner-icon="icons.mdiMagnify"
        ></v-text-field>

        <v-btn-toggle
          v-model="view"
          mandatory
          dense
        >
          <v-btn
            :value="views.rows"
            title="Строки"
            aria-label="Показать строками"
          >
            <v-icon size="20">
              {{ icons.mdiFormatListBulleted }}
            </v-icon>
          </v-btn>
          <v-btn
            :value="views.tiles"
            title="Плитка"
            aria-label="Показать плиткой"
          >
            <v-icon size="20">
              {{ icons.mdiViewGridOutline }}
            </v-icon>
          </v-btn>
        </v-btn-toggle>
      </div>
    </v-card-text>

    <v-divider></v-divider>

    <div class="dish-list__body">
      <v-progress-linear
        v-if="loading"
        indeterminate
        absolute
        top
        height="2"
        color="primary"
      ></v-progress-linear>

      <div
        v-if="loading && !dishes.length"
        class="d-flex justify-center py-12"
      >
        <v-progress-circular
          :size="48"
          :width="4"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </div>

      <v-card-text
        v-else-if="!dishes.length"
        class="text-center py-12 text--secondary"
      >
        {{ filters.searchQuery ? 'По такому запросу блюд не нашлось' : 'В этой категории блюд нет' }}
      </v-card-text>

      <div
        v-else
        :class="{ 'dish-list__content--stale': loading }"
      >
        <dish-table
          v-if="view === views.rows"
          :dishes="dishes"
          @dish-open="openDish"
        ></dish-table>

        <div
          v-else
          class="dish-list__tiles pa-4"
        >
          <dish-card
            v-for="item in dishes"
            :key="item.id"
            :dish="item"
            @dish-open="openDish"
          ></dish-card>
        </div>
      </div>
    </div>

    <v-divider v-if="filters.pageCount > 1"></v-divider>

    <div
      v-if="filters.pageCount > 1"
      class="d-flex justify-center py-4"
    >
      <v-pagination
        v-model="filters.pageNumber"
        :length="filters.pageCount"
        :total-visible="9"
        circle
      ></v-pagination>
    </div>
  </v-card>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { mdiMagnify, mdiFormatListBulleted, mdiViewGridOutline } from '@mdi/js'
import DishCard from './dish-card.vue'
import DishTable from './dish-table.vue'
import {
  DISH_VIEW_ROWS, DISH_VIEW_TILES, readDishView, saveDishView, toDishCount,
} from '@/helpers/menu'

export default {
  name: 'DishList',
  components: { DishCard, DishTable },
  props: ['menuCategory', 'menuVersion', 'categoryName'],
  data: () => ({
    view: readDishView(),
    views: {
      rows: DISH_VIEW_ROWS,
      tiles: DISH_VIEW_TILES,
    },
    icons: {
      mdiMagnify,
      mdiFormatListBulleted,
      mdiViewGridOutline,
    },
  }),
  computed: {
    ...mapState('dish', {
      dishes: 'list',
      totalCount: 'totalCount',
      loading: 'loading',
      filters: 'filters',
    }),
  },
  watch: {
    menuCategory: {
      immediate: true,
      handler(newValue) {
        if (!newValue) return

        if (this.filters.menuCategoryId === newValue) return

        this.filters.pageNumber = 1
        this.filters.menuCategoryId = newValue
      },
    },
    view(newValue) {
      saveDishView(newValue)
    },
  },
  async created() {
    await this.fetchDishes()
  },
  methods: {
    toDishCount,
    ...mapActions('dish', {
      fetchDishes: 'fetchList',
    }),

    openDish(id) {
      this.$router.push({
        name: 'menu-version-dish-form',
        params: { id },
        query: { menuVersionId: this.menuVersion, category: this.menuCategory },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.dish-list__tools {
  gap: 12px;

  @media (max-width: 599px) {
    width: 100%;
  }
}

.dish-list__search {
  flex: none;
  width: 16rem;

  @media (max-width: 599px) {
    flex: 1 1 8rem;
    width: auto;
  }
}

.dish-list__body {
  position: relative;
}

.dish-list__content--stale {
  opacity: 0.5;
  pointer-events: none;
  transition: opacity 0.15s ease;
}

.dish-list__tiles {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;

  @media (min-width: 600px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  @media (min-width: 960px) {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  @media (min-width: 1264px) {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
}
</style>
